import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useIntercom } from 'react-use-intercom';
import { useSpring, config, animated, useSpringRef, useChain } from '@react-spring/web';
import { HandThumbUpIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { Avatar } from 'flowbite-react';
import Image from 'next/image';
import { getAssetSrc, LocaleIcon, useAnalytics, useImageBlob } from '@restworld/utils-common';
import { Button, Title, LinkBase } from '../../../';
import { NavLogo } from '..';
import { Container } from '../navigation-bar-styled';
import HamburgerComponent from './hamburger-component';
import NavMenuContent from './nav-menu-content';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var MobileOverlayNav = /*#__PURE__*/memo(function (props) {
  var _props$background = props.background,
      background = _props$background === void 0 ? 'white' : _props$background,
      isAuthenticated = props.isAuthenticated,
      avatarImage = props.avatarImage,
      isNavOverlay = props.isNavOverlay,
      navOverlayToggler = props.navOverlayToggler,
      _onStartLogin = props.onStartLogin,
      _onStartSignup = props.onStartSignup,
      children = props.children,
      testId = props.testId,
      hideNavElement = props.hideNavElement,
      workerInfo = props.workerInfo,
      onShowUploadCvModal = props.onShowUploadCvModal;

  var _useState = useState(),
      activeItem = _useState[0],
      setActiveItem = _useState[1];

  var isSubItemAvailable = useMemo(function () {
    return Boolean(activeItem === null || activeItem === void 0 ? void 0 : activeItem.subItems.length);
  }, [activeItem === null || activeItem === void 0 ? void 0 : activeItem.subItems.length]);
  var onSelectActiveItem = useCallback(function (value) {
    return setActiveItem(value);
  }, []);
  var onClickMenuToggler = useCallback(function () {
    navOverlayToggler(function (prev) {
      return !prev;
    });
    onSelectActiveItem();
  }, [navOverlayToggler, onSelectActiveItem]);
  useEffect(function () {
    if (isNavOverlay) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return function () {
      document.body.style.overflow = 'auto';
    };
  }, [isNavOverlay]);
  var navRef = useSpringRef();
  var liRef = useSpringRef();
  var subRef = useSpringRef();
  var menuAnimation = useSpring({
    ref: navRef,
    config: config["default"],
    from: {
      transform: 'translateY(-100%)'
    },
    to: {
      transform: isNavOverlay ? 'translateY(0%)' : 'translateY(-100%)'
    }
  }); // On showMenu, start with nav animation, then nav items

  useChain(isNavOverlay ? [navRef, liRef] : [liRef, navRef], [0, isNavOverlay ? 0.4 : 0.6]); // When sub-items are shown, close liRef and open subRef

  useChain(activeItem !== null && activeItem !== void 0 && activeItem.subItems ? [liRef, subRef] : [subRef, liRef], [0, activeItem !== null && activeItem !== void 0 && activeItem.subItems ? 0.4 : 0.6]);
  var avatarImageURL = useImageBlob(avatarImage);
  var isPurpleBackground = useMemo(function () {
    return background === 'purple-gradient' || background === 'home-mobile-nav';
  }, [background]);
  var showFullHeight = isNavOverlay && !isSubItemAvailable;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      justify: "between",
      align: showFullHeight ? 'start' : 'center',
      height: showFullHeight ? 'nav-open' : 'default',
      children: /*#__PURE__*/_jsx(_StyledDiv, {
        children: /*#__PURE__*/_jsxs(StyledNavWrapper, {
          $showFullHeight: showFullHeight,
          children: [/*#__PURE__*/_jsx(_StyledDiv2, {
            children: isSubItemAvailable ? /*#__PURE__*/_jsx(_StyledDiv3, {
              children: /*#__PURE__*/_jsx(Button, {
                variant: "ghost",
                onClick: function onClick() {
                  return onSelectActiveItem();
                },
                children: /*#__PURE__*/_jsx(Title, {
                  content: t('common:back'),
                  icon: isPurpleBackground ? 'ArrowLeftWhiteIcon' : 'ArrowLeftIcon',
                  fontWeight: "semibold",
                  textColor: isPurpleBackground ? 'white' : 'black'
                })
              })
            }) : /*#__PURE__*/_jsx(NavLogo, {
              background: background,
              isSmallLogo: isNavOverlay ? false : Boolean(children)
            })
          }), !isSubItemAvailable && !isNavOverlay && children, /*#__PURE__*/_jsxs(_StyledDiv4, {
            onClick: function onClick() {
              onClickMenuToggler();
            },
            children: [isAuthenticated ? /*#__PURE__*/_jsx(_StyledAvatar, {
              size: "sm",
              alt: "avatar-img",
              rounded: true,
              color: "purple" // Custom img render to ensure non-square source photos get
              // cropped (object-cover) instead of stretched.
              ,
              img: avatarImageURL ? function (imgProps) {
                return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({}, imgProps), {}, {
                  src: avatarImageURL,
                  className: "".concat(imgProps.className, " object-cover")
                }));
              } : undefined
            }) : /*#__PURE__*/_jsx(_StyledDiv5, {
              children: /*#__PURE__*/_jsx(_StyledImage, {
                src: getAssetSrc('/utils-assets/small-restworld-logo.svg'),
                alt: "restworld",
                width: 24,
                height: 20
              })
            }), hideNavElement ? null : /*#__PURE__*/_jsx(_StyledHamburgerComponent, {
              background: background,
              isOpen: isNavOverlay,
              "data-cy": "nav-item-hamburger"
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(StyledNavOverlay, {
      id: "mobile-nav-overlay",
      style: menuAnimation,
      $showFullHeight: showFullHeight,
      "data-cy": testId,
      children: /*#__PURE__*/_jsx(NavMenuContent, {
        onCloseMenu: onClickMenuToggler,
        workerInfo: workerInfo,
        onStartSignup: function onStartSignup() {
          _onStartSignup();
        },
        onStartLogin: function onStartLogin() {
          _onStartLogin();
        },
        onShowUploadCvModal: onShowUploadCvModal
      })
    })]
  });
});
export default MobileOverlayNav;
export var NavLabelItem = /*#__PURE__*/memo(function (_ref) {
  var frontNavItems = _ref.frontNavItems,
      onSelectActiveItem = _ref.onSelectActiveItem,
      avatarName = _ref.avatarName,
      activeItem = _ref.activeItem,
      isAuthenticated = _ref.isAuthenticated,
      transitions = _ref.transitions,
      isPrimary = _ref.isPrimary;

  var _useIntercom = useIntercom(),
      showIntercom = _useIntercom.show;

  var handleClick = useCallback(function (_ref2) {
    var evt = _ref2.evt,
        subItems = _ref2.subItems,
        label = _ref2.label,
        key = _ref2.key,
        icon = _ref2.icon;

    if (subItems !== null && subItems !== void 0 && subItems.length) {
      evt === null || evt === void 0 ? void 0 : evt.preventDefault();
      if (onSelectActiveItem) onSelectActiveItem({
        label: label,
        subItems: subItems,
        icon: icon,
        id: key
      });
    }

    if (key === 'open-intercom') {
      evt === null || evt === void 0 ? void 0 : evt.preventDefault();
      showIntercom();
    }
  }, [onSelectActiveItem, showIntercom]);
  return frontNavItems.length ? /*#__PURE__*/_jsx(_StyledUl, {
    children: transitions(function (style, _ref3, _, index) {
      var label = _ref3.label,
          key = _ref3.key,
          subItems = _ref3.subItems,
          url = _ref3.url,
          icon = _ref3.icon,
          isNotVisible = _ref3.isNotVisible,
          isRecommended = _ref3.isRecommended,
          isUnderlined = _ref3.isUnderlined,
          locale = _ref3.locale;
      return !isNotVisible ? /*#__PURE__*/_jsxs(_StyledAnimatedLi, {
        style: style,
        children: [/*#__PURE__*/_jsxs(LinkBase, {
          link: !(subItems !== null && subItems !== void 0 && subItems.length) ? url : '#!',
          newTab: false,
          onLinkClick: function onLinkClick(evt) {
            return handleClick({
              evt: evt,
              subItems: subItems,
              label: label,
              key: key,
              icon: icon
            });
          },
          twStyle: [{
            "display": "flex",
            "alignItems": "center",
            "justifyContent": "space-between",
            "gap": "0.25rem"
          }, isUnderlined ? {
            "borderBottomWidth": "1px",
            "--tw-border-opacity": "1",
            "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
            "paddingBottom": "2rem"
          } : {}],
          locale: locale,
          children: [/*#__PURE__*/_jsxs(_StyledDiv6, {
            children: [icon, /*#__PURE__*/_jsx(Title, {
              textColor: isRecommended ? 'bold-purple' : 'black',
              content: label,
              fontWeight: isRecommended || isPrimary ? 'semibold' : 'normal',
              standardVariant: "h5"
            }), isRecommended ? /*#__PURE__*/_jsx(RecommendedItem, {}) : null]
          }), subItems !== null && subItems !== void 0 && subItems.length ? /*#__PURE__*/_jsx(Button, {
            icon: "ChevronRightIcon",
            variant: "ghost"
          }) : null]
        }), isAuthenticated && (activeItem === null || activeItem === void 0 ? void 0 : activeItem.label) === avatarName && index === 1 ? /*#__PURE__*/_jsx(_StyledHr, {}) : null]
      }, key) : null;
    })
  }) : null;
});
export var LocaleItem = function LocaleItem(_ref4) {
  var localeComponent = _ref4.localeComponent;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_jsxs(_StyledDiv7, {
    children: [/*#__PURE__*/_jsxs(_StyledDiv8, {
      children: [/*#__PURE__*/_jsx(LocaleIcon, {}), /*#__PURE__*/_jsx(Title, {
        textColor: 'black',
        content: t('common:speech'),
        fontWeight: "semibold",
        standardVariant: "h5"
      })]
    }), localeComponent]
  });
};
export var NonLoggedInButton = /*#__PURE__*/memo(function (_ref5) {
  var onStartLogin = _ref5.onStartLogin,
      onStartSignup = _ref5.onStartSignup,
      twStyle = _ref5.twStyle,
      testId = _ref5.testId;

  var _useTranslation3 = useTranslation(),
      t = _useTranslation3.t;

  var _useAnalytics = useAnalytics(),
      trackEvent = _useAnalytics.trackEvent;

  return /*#__PURE__*/_jsx(NonLoggedInButtonWrapper, {
    twStyle: twStyle,
    children: /*#__PURE__*/_jsxs(_StyledDiv9, {
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "normal",
        title: t('common:log_in'),
        "data-cy": testId,
        onClick: function onClick() {
          onStartLogin();
          trackEvent('initiate_signin', {
            login_state: false,
            user_type: null
          });
        },
        fullwidth: true
      }), /*#__PURE__*/_jsx(Button, {
        variant: "secondary-outline",
        title: t('common:create_account'),
        onClick: function onClick() {
          onStartSignup(); // trackEvent('initiate_create_account', {
          //   origin: 'sidebar',
          // });
        },
        fullwidth: true
      })]
    })
  });
});

var NonLoggedInButtonWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-overlay-nav__NonLoggedInButtonWrapper",
  componentId: "sc-1flnlcv-0"
})(["", ""], function (_ref6) {
  var twStyle = _ref6.twStyle;
  return twStyle;
});

var StyledNavWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-overlay-nav__StyledNavWrapper",
  componentId: "sc-1flnlcv-1"
})(["", " ", ""], {
  "display": "flex",
  "width": "100%",
  "flexGrow": "0",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1rem"
}, function (_ref7) {
  var $showFullHeight = _ref7.$showFullHeight;
  return $showFullHeight ? {
    "maxHeight": "36px"
  } : {};
});

export var StyledNavOverlay = /*#__PURE__*/_styled(animated.div).withConfig({
  displayName: "mobile-overlay-nav__StyledNavOverlay",
  componentId: "sc-1flnlcv-2"
})(function (_ref8) {
  var $showFullHeight = _ref8.$showFullHeight;
  return [{
    "position": "fixed",
    "top": "0px",
    "right": "0px",
    "bottom": "0px",
    "left": "0px",
    "zIndex": "50",
    "boxSizing": "border-box",
    "display": "flex",
    "height": "calc(100svh)",
    "maxWidth": "100vw",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  }, $showFullHeight ? {
    "top": "0px",
    "height": "calc(100svh)"
  } : {}];
});

var RecommendedItem = function RecommendedItem() {
  var _useTranslation4 = useTranslation(),
      t = _useTranslation4.t;

  return /*#__PURE__*/_jsxs(_StyledDiv10, {
    children: [/*#__PURE__*/_jsx(_StyledHandThumbUpIcon, {}), /*#__PURE__*/_jsx(Title, {
      textColor: "bold-purple",
      fontSize: "xSmall",
      fontWeight: "medium",
      twStyle: {
        "lineHeight": "1rem"
      },
      children: t('common:recommended')
    })]
  });
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv",
  componentId: "sc-1flnlcv-3"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1rem",
  "@media (min-width: 768px)": {
    "gap": "1rem"
  }
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv2",
  componentId: "sc-1flnlcv-4"
})({
  "display": "flex",
  "width": "fit-content",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv3",
  componentId: "sc-1flnlcv-5"
})({
  "display": "flex",
  "width": "fit-content",
  "paddingLeft": "0.875rem",
  "@media (min-width: 768px)": {
    "paddingLeft": "0px"
  }
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv4",
  componentId: "sc-1flnlcv-6"
})({
  "display": "flex",
  "width": "fit-content",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var _StyledAvatar = /*#__PURE__*/_styled(Avatar).withConfig({
  displayName: "mobile-overlay-nav___StyledAvatar",
  componentId: "sc-1flnlcv-7"
})({
  "display": "none",
  ":hover": {
    "cursor": "pointer"
  },
  "@media (min-width: 768px)": {
    "display": "inline-flex"
  }
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv5",
  componentId: "sc-1flnlcv-8"
})({
  "display": "none",
  "height": "2rem",
  "width": "2rem",
  "minWidth": "32px",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(226 216 243 / var(--tw-bg-opacity))",
  ":hover": {
    "cursor": "pointer"
  },
  "@media (min-width: 1024px)": {
    "display": "flex"
  }
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "mobile-overlay-nav___StyledImage",
  componentId: "sc-1flnlcv-9"
})({
  "minWidth": "24px"
});

var _StyledHamburgerComponent = /*#__PURE__*/_styled(HamburgerComponent).withConfig({
  displayName: "mobile-overlay-nav___StyledHamburgerComponent",
  componentId: "sc-1flnlcv-10"
})({
  "paddingRight": "0.5rem"
});

var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "mobile-overlay-nav___StyledUl",
  componentId: "sc-1flnlcv-11"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});

var _StyledAnimatedLi = /*#__PURE__*/_styled(animated.li).withConfig({
  displayName: "mobile-overlay-nav___StyledAnimatedLi",
  componentId: "sc-1flnlcv-12"
})({
  "padding": "0.875rem"
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv6",
  componentId: "sc-1flnlcv-13"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.25rem"
});

var _StyledHr = /*#__PURE__*/_styled("hr").withConfig({
  displayName: "mobile-overlay-nav___StyledHr",
  componentId: "sc-1flnlcv-14"
})({
  "marginTop": "2rem"
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv7",
  componentId: "sc-1flnlcv-15"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "0.875rem",
  "paddingRight": "0.875rem"
});

var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv8",
  componentId: "sc-1flnlcv-16"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.25rem"
});

var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv9",
  componentId: "sc-1flnlcv-17"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "width": "fit-content",
    "flexDirection": "row"
  }
});

var _StyledDiv10 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-overlay-nav___StyledDiv10",
  componentId: "sc-1flnlcv-18"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.125rem",
  "borderRadius": "0.375rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(221 238 52 / var(--tw-bg-opacity))",
  "paddingLeft": "0.625rem",
  "paddingRight": "0.625rem",
  "paddingTop": "0.125rem",
  "paddingBottom": "0.125rem"
});

var _StyledHandThumbUpIcon = /*#__PURE__*/_styled(HandThumbUpIcon).withConfig({
  displayName: "mobile-overlay-nav___StyledHandThumbUpIcon",
  componentId: "sc-1flnlcv-19"
})({
  "height": "0.875rem",
  "width": "0.875rem",
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))"
});